import { currentEnv } from "./config";

interface ApiEndpoints {
    userAuth: string;
    userContact: string;
    getQuestion: string;
    saveAnswer: string;
    submitSurvey: string;
}

var version = currentEnv == "development" ? "/mock" : "/v1"
version = "/v1";

export const apiEndpoints: ApiEndpoints = {
    userAuth: `${version}/user/auth`,
    userContact: `${version}/user/contact`,
    getQuestion: `${version}/survey/question`, 
    saveAnswer: `${version}/survey/answer`,
    submitSurvey: `${version}/survey/submit`
};